var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.998 10.392L21.816 1.5h-1.853l-6.788 7.72L7.753 1.5H1.5l8.199 11.675L1.5 22.5h1.853l7.168-8.153 5.726 8.153H22.5l-8.503-12.108zm-2.538 2.886l-.83-1.162-6.61-9.251h2.846L12.2 10.33l.83 1.163 6.934 9.704h-2.846L11.46 13.28z",
    fill: "#000"
  })));
}

export default SvgIconX;